module.exports = __webpack_public_path__ + "static/img/up-corner-8m-x-4m-inverted_256.8067343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-8m-x-4m-inverted_256.png
// module id = NQ1T
// module chunks = 0